export const validateForm = (fields, values, defaultMessage, customValidators) => {
  const errors = fields.reduce((acc, field) => {
    if (customValidators[field] && !customValidators[field].regex.test(values[field])) {
      return {
        ...acc,
        [field]: customValidators[field].message,
      }
    }
    if (!values[field] || values[field] === "null") {
      return { ...acc, [field]: defaultMessage }
    }
    return acc
  }, {})
  return errors
}

export const REGEXES = {
  email:
    /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?/,
  password: /^(?=.*[a-zA-Z0-9!@#$%^&*])(?=.{6,72})/,
}
